import { StoreType } from 'types/store'
import { db, FirebaseDocRefType } from 'firebase/index'

export const fetchStoreByRef = (storeRef: FirebaseDocRefType): Promise<StoreType | undefined> => {
  return storeRef
    .get()
    .then((snapshot) => {
      return snapshot.data() as StoreType
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchStores = (statuses: string[]): Promise<StoreType[]> => {
  return db
    .collection('stores')
    .where('status', 'in', statuses)
    .orderBy('name', 'asc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as StoreType
        data.store_id = snapshot.ref.id
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const publishFirstStock = (storeRef: FirebaseDocRefType) => {
  return storeRef.update({ is_before_publishing_stock: false })
}

export const fetchWebHostnames = async (): Promise<string[]> => {
  const webHostnames: string[] = []
  await db
    .collection('stores')
    .get()
    .then((snapshots) => {
      return snapshots.docs.forEach((snapshot) => {
        const data = snapshot.data() as StoreType
        if (data.web_hostname) {
          webHostnames.push(data.web_hostname)
        }
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
  return webHostnames
}
